/* Bhumi Gems storefront enhancements.
 * 1. Sale badges: replace the generic "Sale" label with the real saving ("Save 25%"),
 *    computed from the compare-at and sale prices already rendered in the price block.
 * 2. Image protection: no right-click menu, dragging or long-press saving on photos.
 *    This deters casual copying; it cannot stop screenshots or developer tools.
 */
(function () {
  function amount(el) {
    if (!el) return null;
    var n = parseFloat(String(el.textContent).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : n;
  }

  function savingFor(priceEl) {
    var sale = priceEl.querySelector('.price__sale');
    if (!sale) return null;
    var regular = amount(sale.querySelector('.price-item--regular'));
    var current = amount(sale.querySelector('.price-item--sale'));
    if (!regular || !current || current >= regular) return null;
    return Math.round(((regular - current) / regular) * 100);
  }

  function apply(root) {
    (root || document).querySelectorAll('.price.price--on-sale').forEach(function (priceEl) {
      var pct = savingFor(priceEl);
      if (!pct) return;
      var label = 'Save ' + pct + '%';
      // Product cards keep the badge in the card media, outside the price block.
      var card = priceEl.closest('.card-wrapper, .card');
      var badges = card ? card.querySelectorAll('.card__badge .badge') : [];
      // Product pages show the badge inside the price block.
      var own = priceEl.querySelectorAll('.price__badge-sale');
      [].forEach.call(badges, function (b) { if (b.textContent.trim() !== label) b.textContent = label; });
      [].forEach.call(own, function (b) { if (b.textContent.trim() !== label) b.textContent = label; });
    });
  }

  function isPhoto(target) {
    return target && target.closest && target.closest('img, picture, video, .product__media, .card__media, .bh-hero__media, .bh-cat__frame, .bh-split__media, .product-media-modal');
  }

  function protectImages() {
    document.addEventListener('contextmenu', function (e) { if (isPhoto(e.target)) e.preventDefault(); });
    document.addEventListener('dragstart', function (e) { if (isPhoto(e.target)) e.preventDefault(); });
  }

  function start() {
    apply(document);
    protectImages();
    // Variant changes, filters and infinite pagination re-render price blocks.
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; apply(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
